export const Constants = {
    ANDROID_URL: 'https://play.google.com/store/apps/details?id=com.zadanetwork.wallet&hl=en&gl=US',
    IOS_URL: 'https://apps.apple.com/us/app/zada-wallet/id1578666669',
}
